import { Grid } from '@material-ui/core';
import {
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  Icons,
  MaterialPalette,
  Typography,
} from '@nutrien/cxp-components';
import localforage from 'localforage';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import { Subscription } from 'rxjs';

import { useMst } from '../../mobx-models/Root';
import { FileCategory, ISignAndStampData } from '../../models/models';
import { SignAndStampFile, SignAndStampFileDocument } from '../../rxdb/signAndStamp/queryBuilder';
import useSignAndStamp from '../../rxdb/signAndStamp/useSignAndStamp';
import { useSignAndStampFile } from '../../rxdb/signAndStamp/useSignAndStampFile';
import { SignAndStampUserLevelDocument } from '../../rxdb/signAndStampUserLevel/queryBuilder';
import { useSignAndStampUserLevel } from '../../rxdb/signAndStampUserLevel/useSignAndStampUserLevel';
import { TaskList } from '../../rxdb/taskList/queryBuilder';
import { useTaskList } from '../../rxdb/taskList/useTaskList';
import { isJestTest } from '../../test-helpers/isJestTest';
import { sentryCaptureException, useFileStorage, useNotification } from '../../utilities';
import {
  ADHOC_LI_SIGN_OFF_DONE_SUBMIT_TO_SC,
  ADHOC_SUBMIT_FOR_LI_SIGN_OFF,
  ALLOW_EXTENSIONS,
  INVALID_FILE,
  INVALID_FILE_TYPE,
  SPECIAL_CHARACTER_ERROR,
  TRUE,
  UPDATING_SIGN_AND_STAMP,
} from '../../utilities/constants';
import { TaskStatus } from '../../utilities/enums';
import {
  checkFileCorruption,
  getLocalStorageCurrentUserId,
  hasSpecialCharacter,
} from '../../utilities/utilityFunctions';
import SignAndStampCompletedView from '../SignAndStampCompletedView';
import SignAndStampFIView from '../SignAndStampFIView';
import SignAndStampNoImage from '../SignAndStampNoImage';
import UserConsent from '../UserSignatureAndStamp/UserConsent';
import signAndStampStyles from './SignAndStamp.styles';
localforage.createInstance({
  name: 'attachment-store',
});

interface Props {
  taskData: TaskList;
}

const SignAndStampFI: React.FC<Props> = ({ taskData }) => {
  const classes = signAndStampStyles();
  const signatureCanvasHeight = '500';
  const localStorageCurrentUserId = getLocalStorageCurrentUserId();
  const { CurrentUserSelected } = useMst();
  const isAdhoc = CurrentUserSelected.isAdhoc;
  const taskId = CurrentUserSelected.taskId;
  let signatureCanvas: SignatureCanvas | null;
  const { uploadSignAndStamp, getAttachmentFromIndexDB } = useFileStorage();
  const [isSignature, setIsSignature] = useState<boolean>(false);
  const [confirmationForSignAndStamp, setConfirmationForSignAndStamp] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<ISignAndStampData[]>([]);
  const [SignAndStampFileData, setSignAndStampFileData] = useState<SignAndStampFile[]>();
  const [signData, setSignData] = useState<ISignAndStampData>();
  const [stampData, setStampData] = useState<ISignAndStampData>();
  const [userSignData, setUserSignData] = useState<ISignAndStampData>();
  const [userStampData, setUserStampData] = useState<ISignAndStampData>();
  const [taskSignData, setTaskSignData] = useState<ISignAndStampData>();
  const [taskStampData, setTaskStampData] = useState<ISignAndStampData>();
  const [isUploadButDisable, setIsUploadButDisable] = useState<boolean>(true);
  const [isSaveCheckDisable, setIsSaveCheckDisable] = useState<boolean>(true);
  const [isSaveForFuture, setIsSaveForFuture] = useState<boolean>(false);
  const [deleteUserFiles, setDeleteUserFiles] = useState<ISignAndStampData[]>([]);
  const [openUserConsent, setOpenUserConsent] = useState<boolean>(false);
  const [isAccepted, setIsAccepted] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [disableCheckedCheckbox, setDisableCheckedCheckbox] = useState<boolean>(false);
  const [openAlert, setIsOpenAlert] = useState<boolean>(false);
  const [isUserConsentEnable, setIsUserConsentEnable] = useState<boolean>(false);
  const isCompletedSignView = [TaskStatus.SC_PENDING_APPROVAL, TaskStatus.COMPLETED].includes(
    taskData.fkInspectionTaskStatusCategory,
  );
  const isFiSignVisible =
    [TaskStatus.LI_PENDING_APPROVAL, TaskStatus.LI_SIGN_PENDING].includes(
      taskData.fkInspectionTaskStatusCategory,
    ) && !taskData.clerkId;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { setTaskListInfo } = useTaskList();
  const { successNotification, errorNotification } = useNotification();
  const history = useHistory();
  const {
    signAndStampFileInitialized,
    signAndStampFileCollection,
    deleteSignAndStampFile,
    getSignAndStampFiles,
  } = useSignAndStampFile();
  const [signAndStampFileUpdateSubscription, setSignAndStampFileUpdateSubscription] =
    useState<Subscription>();
  const {
    signAndStampUserLevelInitialized,
    signAndStampUserLevelCollection,
    getSignAndStampUserLevel,
  } = useSignAndStampUserLevel();
  const [signAndStampUserLevelUpdateSubscription, setSignAndStampUserLevelUpdateSubscription] =
    useState<Subscription>();
  const { isLISignAvailable } = useSignAndStamp(
    String(CurrentUserSelected.inspectionId),
    CurrentUserSelected.taskId,
  );

  const label2 = (
    <Grid item container>
      <Typography color="textPrimary" variant="body1" className={classes.content}>
        Please review
      </Typography>
      {!isUserConsentEnable && (
        <Typography color="textSecondary" className={classes.spanMsgDisable}>
          User Consent
        </Typography>
      )}
      {isUserConsentEnable && (
        <Typography
          color="primary"
          className={classes.spanMsg}
          onClick={() => setOpenUserConsent(true)}
          data-testid="user-consent-text"
        >
          User Consent
        </Typography>
      )}
      <Typography color="textPrimary" variant="body1" className={classes.content}>
        for saving Signature and Stamp Image
      </Typography>
    </Grid>
  );

  const getSignAndStampFilesFromRxDB = async () => {
    if (signAndStampFileCollection) {
      const signAndStampFileRxDocument: SignAndStampFileDocument[] = await getSignAndStampFiles();
      if (signAndStampFileRxDocument) {
        setSignAndStampFileData(signAndStampFileRxDocument);
        const signTaskData = signAndStampFileRxDocument.find(
          (item: SignAndStampFileDocument) =>
            item.fileCategory === FileCategory.Sign &&
            item.fkAssetInspectionTask === taskId &&
            !item.userId,
        );
        if (signTaskData) {
          const data: ISignAndStampData = {
            fileUUID: signTaskData.fileUUID,
            updatedName: signTaskData.name,
            category: signTaskData.fileCategory,
            filePath: signTaskData.originalPath,
          };
          setTaskSignData(data);
        }
        const stampTaskData = signAndStampFileRxDocument.find(
          (item: SignAndStampFileDocument) =>
            item.fileCategory === FileCategory.Stamp &&
            item.fkAssetInspectionTask === taskId &&
            !item.userId,
        );
        if (stampTaskData) {
          const data: ISignAndStampData = {
            fileUUID: stampTaskData.fileUUID,
            updatedName: stampTaskData.name,
            category: stampTaskData.fileCategory,
            filePath: stampTaskData.originalPath,
          };
          setTaskStampData(data);
        }
      }
    }
  };

  const subscribeToSignAndStampFile = async () => {
    if (signAndStampFileInitialized && signAndStampFileCollection) {
      const signAndStampUpdateSub = signAndStampFileCollection.find().$.subscribe(() => {
        getSignAndStampFilesFromRxDB();
      });
      setSignAndStampFileUpdateSubscription(signAndStampUpdateSub);
    }
  };

  const getSignAndStampUserLevelFromRxDB = async () => {
    if (signAndStampUserLevelCollection) {
      const signAndStampUserLevelRxDocument: SignAndStampUserLevelDocument[] =
        await getSignAndStampUserLevel();
      if (signAndStampUserLevelRxDocument) {
        const signUserData = signAndStampUserLevelRxDocument.find(
          (item: SignAndStampUserLevelDocument) =>
            item.fileCategory === FileCategory.Sign &&
            item.userId === localStorageCurrentUserId &&
            item.isSaveForFuture === true &&
            item.isDelete?.toLowerCase() === 'false',
        );
        if (signUserData) {
          const data: ISignAndStampData = {
            fileUUID: signUserData.fileUUID,
            updatedName: signUserData.name,
            category: signUserData.fileCategory,
            filePath: signUserData.originalPath,
          };
          setSignData(undefined);
          setUserSignData(data);
        }
        const stampUserData = signAndStampUserLevelRxDocument.find(
          (item: SignAndStampUserLevelDocument) =>
            item.fileCategory === FileCategory.Stamp &&
            item.userId === localStorageCurrentUserId &&
            item.isSaveForFuture === true &&
            item.isDelete?.toLowerCase() === 'false',
        );
        if (stampUserData) {
          const data: ISignAndStampData = {
            fileUUID: stampUserData.fileUUID,
            updatedName: stampUserData.name,
            category: stampUserData.fileCategory,
            filePath: stampUserData.originalPath,
          };
          setStampData(undefined);
          setUserStampData(data);
        }
      }
    }
  };

  const subscribeToSignAndStampUserLevel = async () => {
    if (signAndStampUserLevelInitialized && signAndStampUserLevelCollection) {
      const signAndStampUserLevelUpdateSub = signAndStampUserLevelCollection
        .find()
        .$.subscribe(() => {
          getSignAndStampUserLevelFromRxDB();
        });
      setSignAndStampUserLevelUpdateSubscription(signAndStampUserLevelUpdateSub);
    }
  };

  const onOpenUploadForSign = async () => {
    document.getElementById('selectImageForSign')?.click();
  };

  const onOpenUploadForStamp = async () => {
    document.getElementById('selectImageForStamp')?.click();
  };

  const onFilesSelected = async (images: ISignAndStampData[]) => {
    await setSelectedFiles(images);
  };

  const autoVersionIfFileExists = (name: string, index = 0): string => {
    let newName = name,
      ext = '';
    if (index) {
      if (newName.indexOf('.') > -1) {
        const tokens = newName.split('.');
        ext = '.' + tokens.pop();
        newName = tokens.join('.');
      }
      newName = `${newName} (${index})${ext}`;
    }
    const nameExists =
      selectedFiles.filter((f: ISignAndStampData) => f.updatedName === newName).length > 0;
    return nameExists ? autoVersionIfFileExists(name, index + 1) : newName;
  };

  const uploadStampImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const file: File = e.target.files[0];
    if (!ALLOW_EXTENSIONS.exec(file.name)) {
      errorNotification(INVALID_FILE_TYPE);
      return;
    }
    if (hasSpecialCharacter(file.name)) {
      errorNotification(SPECIAL_CHARACTER_ERROR);
      return;
    }
    let validItem = null;
    validItem = await checkFileCorruption([file]);
    if (!validItem.length) {
      errorNotification(INVALID_FILE);
      return;
    }
    if (file) {
      const fileData = {
        fileData: file,
        updatedName: autoVersionIfFileExists(file.name),
        category: FileCategory.Stamp,
        isSignature: false,
      };
      setDisableCheckedCheckbox(false);
      setStampData(fileData);
      setSelectedFiles(arr => [...arr, ...[fileData]]);
    }
  };

  const uploadSignImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const file: File = e.target.files[0];
    if (!ALLOW_EXTENSIONS.exec(file.name)) {
      errorNotification(INVALID_FILE_TYPE);
      return;
    }
    if (hasSpecialCharacter(file.name)) {
      errorNotification(SPECIAL_CHARACTER_ERROR);
      return;
    }
    let validItem = null;
    validItem = await checkFileCorruption([file]);
    if (!validItem.length) {
      errorNotification(INVALID_FILE);
      return;
    }
    if (file) {
      const fileData = {
        fileData: file,
        updatedName: autoVersionIfFileExists(file.name),
        category: FileCategory.Sign,
        isSignature: false,
      };
      setDisableCheckedCheckbox(false);
      setSignData(fileData);
      setSelectedFiles(arr => [...arr, ...[fileData]]);
    }
  };

  const onsetDeleteUserFiles = async (data: ISignAndStampData[]) => {
    setDeleteUserFiles(data);
  };

  const handleFileDelete = async (fileId: string, fileCategory: number) => {
    try {
      switch (fileCategory) {
        case FileCategory.Sign:
        case FileCategory.Stamp:
          await deleteSignAndStampFile(fileId.toString(), TRUE);
          onsetDeleteUserFiles(deleteUserFiles.filter(image => image.fileUUID !== fileId));
          break;
      }
    } catch (error) {
      console.log('🚀 ~ file: signAndSigmpFI.tsx ~ line 284 ~ handleFileDelete ~ error', error); // eslint-disable-line no-console
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(error, '~ file: signAndSigmpFI.tsx ~ line 284 ~ handleFileDelete ~');
    }
  };

  const handleDelete = (file: ISignAndStampData) => {
    if (file.fileUUID) {
      if (userSignData && userSignData?.fileUUID === file.fileUUID) {
        setUserSignData(undefined);
      }
      if (userStampData && userStampData?.fileUUID === file.fileUUID) {
        setUserStampData(undefined);
      }
    } else {
      if (file.category === FileCategory.Sign) {
        setSignData(undefined);
      } else if (file.category === FileCategory.Stamp) {
        setStampData(undefined);
      }
    }

    if (deleteUserFiles) {
      deleteUserFiles.map(image => {
        if (image.fileUUID && file.fileUUID && image.fileUUID === file.fileUUID) {
          handleFileDelete(image.fileUUID, image.category);
        }
      });
    }
    onFilesSelected(
      selectedFiles.filter((image: ISignAndStampData) => image.updatedName !== file.updatedName),
    );
  };

  const handleImageUploads = async (fileList: ISignAndStampData[]) => {
    const files = [...fileList];
    files.forEach((file, index) => {
      files[index].isSaveForFuture = isSaveForFuture;
      files[index].isInspection = false;
    });
    if (isSaveForFuture && deleteUserFiles) {
      files.forEach((file, index) => {
        deleteUserFiles.forEach((dFile, dIndex) => {
          if (files[index].updatedName === deleteUserFiles[dIndex].updatedName) {
            files[index].isSaveForFuture = false;
          }
        });
      });
    }

    try {
      await Promise.all(
        files.map(async (signAndStampData: ISignAndStampData) => {
          const fileData: File = signAndStampData.fileData as File;
          if (signAndStampData.isSaveForFuture) {
            await uploadSignAndStamp(
              `signAndStamp/${localStorageCurrentUserId}`,
              fileData,
              signAndStampData,
            );
          }
        }),
      );
    } catch (error) {
      console.log('🚀 ~ file: signAndSigmpFI.tsx ~ line 302 ~ handleImageUploads ~ error', error); // eslint-disable-line no-console
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(error, '~ file: signAndSigmpFI.tsx ~ line 415 ~ handleImageUploads ~');
    }

    try {
      await Promise.all(
        files.map(async (signAndStampData: ISignAndStampData) => {
          const fileData: File = signAndStampData.fileData as File;
          const tempData = signAndStampData;
          tempData.isSaveForFuture = false;
          await uploadSignAndStamp(`signAndStamp/${taskId}`, fileData, signAndStampData);
        }),
      );
    } catch (error) {
      console.log('🚀 ~ file: signAndSigmpFI.tsx ~ line 409 ~ handleImageUploads ~ error', error); // eslint-disable-line no-console
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(error, '~ file: signAndSigmpFI.tsx ~ line 409 ~ handleImageUploads ~');
    }
    await setTaskListInfo(
      isAdhoc && isLISignAvailable ? TaskStatus.SC_PENDING_APPROVAL : TaskStatus.LI_SIGN_PENDING,
    );
    setIsLoading(false);
    history.push(`/${isAdhoc ? 'work-packages' : 'inspection-list'}`);
    successNotification('Sign and Stamp Submitted Successfully');
  };

  const getSignature = async () => {
    const val = signatureCanvas?.toDataURL();
    const blob = await fetch(val as string).then(r => r.blob());
    const objectURL = URL.createObjectURL(blob);
    const fileName = 'sign.png';
    const file = new File([objectURL], `${fileName}`, { type: 'image/png' });
    const fileData = {
      fileData: file,
      updatedName: autoVersionIfFileExists(file.name),
      category: FileCategory.Sign,
      isSignature: true,
      isSaveForFuture,
      blob,
    };
    return fileData;
  };

  const handleSignAndStamp = async () => {
    if (isSignature) {
      const fileData = await getSignature();
      selectedFiles.push(fileData);
    }
    await handleImageUploads(selectedFiles);
  };

  const editImageFile = async (dataURL: string, fileName: string) => {
    const blobUrl = isJestTest() ? '' : await (await fetch(dataURL)).blob();
    const file = new File([blobUrl], `${fileName}`, { type: 'image/jpeg' });
    return file;
  };

  const getS3URL = async (fileId: string) => {
    const blobFile: Blob = (await getAttachmentFromIndexDB(fileId)) as Blob;
    const url = blobFile ? URL.createObjectURL(blobFile) : '';
    return url;
  };

  const setUrlToFile = async (data: ISignAndStampData) => {
    const url = await getS3URL(data.fileUUID as string);
    if (url !== '') {
      const file = await editImageFile(url, data.updatedName);
      const fileData: ISignAndStampData = {
        fileUUID: data.fileUUID,
        fileData: file as File,
        updatedName: data.updatedName,
        category: data.category,
        isSignature: false,
        isSaveForFuture: false,
      };
      setSelectedFiles(prevArr => {
        const filteredArr = prevArr.filter(item => item.fileUUID !== fileData.fileUUID);
        return [...filteredArr, ...[fileData]];
      });
      setDeleteUserFiles(prevArr => {
        const filteredArr = prevArr.filter(item => item.fileUUID !== fileData.fileUUID);
        return [...filteredArr, ...[fileData]];
      });
    }
  };

  useEffect(() => {
    //user consent hyperlink enable/disable
    if (signData || isSignature || stampData) {
      setIsUserConsentEnable(true);
      setDisableCheckedCheckbox(false);
    } else if (!signData && !isSignature && !stampData) {
      setIsUserConsentEnable(false);
    }
  }, [isSignature, signData, stampData]);

  useEffect(() => {
    //upload button
    if (signData || isSignature || userSignData) {
      setIsUploadButDisable(false);
    } else if (!signData && !isSignature && !userSignData) {
      setIsUploadButDisable(true);
    }
  }, [isSignature, signData, stampData, userSignData]);

  useEffect(() => {
    //user consent checkbox enbale/disable
    if (signData || isSignature || stampData) {
      setIsSaveCheckDisable(false);
    } else if (!signData && !isSignature && !stampData) {
      setIsSaveCheckDisable(true);
    }
  }, [isSignature, signData, stampData]);

  useEffect(() => {
    //consent checkbox check
    if (!signData && !isSignature && !stampData && isChecked) {
      setIsChecked(false);
    }
  }, [isSignature, signData, stampData]);

  useEffect(() => {
    if (userSignData || userStampData) {
      if (userSignData && userSignData.fileUUID) {
        setUrlToFile(userSignData);
      }
      if (userStampData && userStampData.fileUUID) {
        setUrlToFile(userStampData);
      }
    }
  }, [userSignData, userStampData]);

  useEffect(() => {
    setIsSaveForFuture(isChecked);
  }, [isChecked]);

  useEffect(() => {
    if (!isSignature && userSignData) {
      setIsUploadButDisable(false);
      setDisableCheckedCheckbox(true);
    }
  }, [isSignature, userSignData, userStampData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsAccepted(false);
    if (isAccepted) {
      setIsChecked(e.target.checked);
      setIsOpenAlert(false);
    } else {
      setIsOpenAlert(true);
    }
  };

  useEffect(() => {
    if (signAndStampFileInitialized) {
      getSignAndStampFilesFromRxDB();
      subscribeToSignAndStampFile();
    }
    return () => {
      if (signAndStampFileUpdateSubscription) signAndStampFileUpdateSubscription.unsubscribe();
    };
  }, [signAndStampFileInitialized]);

  useEffect(() => {
    if (signAndStampUserLevelInitialized) {
      getSignAndStampUserLevelFromRxDB();
      subscribeToSignAndStampUserLevel();
    }
    return () => {
      if (signAndStampUserLevelUpdateSubscription)
        signAndStampUserLevelUpdateSubscription.unsubscribe();
    };
  }, [signAndStampUserLevelInitialized]);

  const handleKeyEvent = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && !isUploadButDisable) {
      setConfirmationForSignAndStamp(true);
    }
  };

  useEffect(() => {
    if (!signData && !stampData && !isSignature && !userSignData && !userStampData) {
      setIsUploadButDisable(true);
      setIsUserConsentEnable(false);
      setIsChecked(false);
    }
  }, [signData, stampData, isSignature, userSignData, userStampData]);

  return (
    <>
      {isAdhoc && taskData.fkInspectionTaskStatusCategory === TaskStatus.FI_SIGN_PENDING && (
        <Grid
          onKeyUp={handleKeyEvent}
          xs={12}
          container
          className={classes.signStampContainer}
          tabIndex={2}
        >
          <Grid container xs={12}>
            <Grid item xs={6} className={classes.signStampFITitleGrid}>
              <Typography className="signStampFITitle">Signature and Stamping</Typography>
            </Grid>
          </Grid>
          <Grid xs={6} className={classes.signStampTitle}>
            <Typography variant="h5" />
          </Grid>

          <Grid item xs={12} className={classes.signatureContainer}>
            {userSignData && (
              <SignAndStampFIView data={userSignData} onDelete={handleDelete} readonly={false} />
            )}
            {signData && (
              <SignAndStampFIView data={signData} onDelete={handleDelete} readonly={false} />
            )}
            {!userSignData && !signData && (
              <>
                {isSignature && (
                  <Grid
                    item
                    container
                    xs={12}
                    justifyContent="flex-end"
                    className={classes.signStampTitle}
                  >
                    <Typography
                      variant="h5"
                      className="clearSignText"
                      onClick={() => {
                        signatureCanvas?.clear();
                        setIsSignature(false);
                      }}
                    >
                      {`Clear Sign`}
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <SignatureCanvas
                    ref={ref => {
                      signatureCanvas = ref;
                    }}
                    penColor={`${MaterialPalette.text.disabled}`}
                    backgroundColor="#404040"
                    canvasProps={{
                      height: signatureCanvasHeight,
                      className: classes.signCanvas,
                      style: { maxWidth: '100%', borderRadius: '4px' },
                    }}
                    onBegin={() => {}}
                    onEnd={() => {
                      setIsSignature(true);
                      setDisableCheckedCheckbox(false);
                    }}
                  />
                </Grid>
              </>
            )}
            {!isSignature && !userSignData && !signData && (
              <Grid item container justifyContent="center" className={classes.signLabelDiv}>
                <Typography className={classes.signLabel}>
                  {`Digitally sign above to complete this inspection `}
                </Typography>
                <Typography className={classes.signLabel}>{`OR `}</Typography>
                <Grid item className={classes.signUploadButDiv}>
                  <Button
                    color="primary"
                    className={classes.signUploadButton}
                    noMinHeight
                    onClick={onOpenUploadForSign}
                  >
                    <Grid className={classes.uploadButtonSignGrid}>
                      <Typography variant="subtitle2" className="uploadButtonSign">
                        Upload Signature*
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          id="selectImageForSign"
                          onClick={() => {}}
                          onChange={uploadSignImage}
                          data-testid="upload-sign-file"
                        />
                      </Typography>
                    </Grid>
                  </Button>
                </Grid>
              </Grid>
            )}
          </Grid>

          <Grid item xs={12} className={classes.stampContainer}>
            {!userStampData && !stampData && (
              <Grid container className={classes.stampUploadContainer}>
                <Grid container justifyContent="center">
                  <Grid className={classes.stampLabelDiv}>
                    <Typography>Select and Upload the Stamp Image</Typography>
                  </Grid>
                  <Grid
                    container
                    justifyContent="center"
                    item
                    onClick={onOpenUploadForStamp}
                    className={classes.uploadIconGrid}
                  >
                    <Icons.UploadFeather color="primary" height="40px" width="40px" />
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      id="selectImageForStamp"
                      onClick={() => {}}
                      onChange={uploadStampImage}
                      data-testid="upload-stamp-file"
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}
            {userStampData && (
              <SignAndStampFIView data={userStampData} onDelete={handleDelete} readonly={false} />
            )}
            {stampData && (
              <SignAndStampFIView data={stampData} onDelete={handleDelete} readonly={false} />
            )}
          </Grid>
          <Grid
            item
            xs={12}
            container
            justifyContent="flex-end"
            alignItems="center"
            className={classes.accordianRightDiv}
          >
            <Grid item className={classes.floatLeftGrid}>
              {
                <Grid container className={classes.checkboxGrid}>
                  {disableCheckedCheckbox ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={true}
                          color="primary"
                          checked={true}
                          className={classes.checkBoxUserConsent}
                        />
                      }
                      label={label2}
                    />
                  ) : (
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={isSaveCheckDisable}
                          color="primary"
                          checked={isChecked}
                          onChange={e => handleChange(e)}
                          className={classes.checkBoxUserConsent}
                          inputProps={{
                            'data-testid': 'save-for-future-checkbox',
                          }}
                        />
                      }
                      label={label2}
                    />
                  )}
                </Grid>
              }
              {openAlert && (
                <Grid className={classes.errorGrid}>
                  <Icons.AlertCircleIcon color="error" />
                  <Typography color="error" variant="body2">
                    Complete reading User Consent
                  </Typography>
                </Grid>
              )}
            </Grid>
            <Grid item className={classes.floatRightGrid}>
              <Button
                id={isUploadButDisable ? 'uploadButtonDisabled' : 'uploadButton'}
                className={isUploadButDisable ? 'uploadButtonDisabled' : classes.uploadButton}
                disabled={isUploadButDisable}
                noMinHeight
                color="primary"
                variant="contained"
                onClick={() => setConfirmationForSignAndStamp(true)}
                isLoading={false}
                data-testid="sign-and-stamp-FI-upload"
              >
                <Icons.UploadFeather
                  height="20px"
                  width="20px"
                  className={classes.uploadSendButton}
                />
                <Grid className={classes.accordianButtonLabelGrid}>
                  <Typography className="accordianButtonLabel">Upload & Send</Typography>
                </Grid>
              </Button>
            </Grid>
          </Grid>
          {confirmationForSignAndStamp && (
            <Dialog
              onClose={() => {
                setConfirmationForSignAndStamp(false);
              }}
              open={confirmationForSignAndStamp}
              titleText="Confirmation"
              backButton={false}
              dialogActions={
                <Grid container justifyContent="space-between" spacing={2}>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      noMinHeight
                      onClick={() => setConfirmationForSignAndStamp(false)}
                      data-testid="cancel-sign-and-stamp-upload"
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item className={classes.confirmButtonDiv}>
                    <Button
                      isLoading={isLoading}
                      variant="contained"
                      color="primary"
                      noMinHeight
                      onClick={() => {
                        handleSignAndStamp();
                        setSelectedFiles([]);
                        setIsLoading(true);
                      }}
                      data-testid="save-sign-and-stamp-upload"
                    >
                      Yes, Send
                    </Button>
                  </Grid>
                </Grid>
              }
              maxWidth="xs"
              noMinHeight
            >
              <Grid container className={classes.confirmationContainer}>
                <Grid item container xs={12} alignItems="center">
                  <Typography className={classes.dialogText}>
                    {isAdhoc
                      ? isLISignAvailable
                        ? ADHOC_LI_SIGN_OFF_DONE_SUBMIT_TO_SC
                        : ADHOC_SUBMIT_FOR_LI_SIGN_OFF
                      : UPDATING_SIGN_AND_STAMP}
                  </Typography>
                </Grid>
              </Grid>
            </Dialog>
          )}
        </Grid>
      )}
      {isFiSignVisible && (
        <Grid xs={12} container className={classes.signStampContainer}>
          <Grid container xs={12}>
            <Grid item xs={6} className={classes.signStampFITitleGrid}>
              <Typography className="signStampFITitle">FI Signature and Stamp</Typography>
            </Grid>
          </Grid>
          <Grid xs={6} className={classes.signStampTitle}>
            <Typography variant="h5" />
          </Grid>
          <Grid item xs={12} className={classes.signatureContainer}>
            {taskSignData && <SignAndStampFIView data={taskSignData} readonly={true} />}
            {!taskSignData && <SignAndStampNoImage message="No Sign Uploaded" />}
          </Grid>

          <Grid item xs={12} className={classes.stampContainer}>
            {!taskStampData && <SignAndStampNoImage message="No Stamp Uploaded" />}
            {taskStampData && <SignAndStampFIView data={taskStampData} readonly={true} />}
          </Grid>
        </Grid>
      )}
      {isCompletedSignView && <SignAndStampCompletedView data={SignAndStampFileData} />}
      {openUserConsent && (
        <UserConsent
          open={openUserConsent}
          onClose={() => setOpenUserConsent(false)}
          setIsAccepted={setIsAccepted}
          setIsChecked={setIsChecked}
          setIsOpenAlert={setIsOpenAlert}
        />
      )}
    </>
  );
};
export default SignAndStampFI;
